import React from 'react';
import {  FaBehance, FaGithub, FaInstagram, FaLink } from 'react-icons/fa'; // Utilisation de FaLink pour Linktree
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faBluesky } from '@fortawesome/free-brands-svg-icons';
import { FaBlogger } from 'react-icons/fa'; // Import de l'icône Blogger
import styled from 'styled-components';

// Styled components pour le footer
const FooterWrapper = styled.footer`
  background-color: ${props => (props.isDarkMode ? '#333' : '#f8f8f8')};
  color: ${props => (props.isDarkMode ? '#fff' : '#333')};
  padding: 20px;
  text-align: center;
`;

const FooterContent = styled.div`
  max-width: 1200px;
  margin: 0 auto;
  display: flex;
  flex-direction: column;
  align-items: center;
`;

const SocialMediaWrapper = styled.div`
  margin: 10px 0;
  display: flex;
  justify-content: center;
  gap: 20px;
`;

const SocialIcon = styled.a`
  color: inherit;
  font-size: 30px;
  transition: color 0.3s ease;

  &:hover {
    color: ${props => (props.isDarkMode ? '#ff6347' : '#2d89ff')}; /* Change color on hover */
  }
`;

const Credit = styled.p`
  margin-top: 20px;
  font-size: 14px;
  color: ${props => (props.isDarkMode ? '#dddddd' : '#555')};
`;

const PrivacyPolicyLink = styled.a`
  font-size: 14px;
  color: ${props => (props.isDarkMode ? '#ddd' : '#555')};
  text-decoration: none;
  transition: color 0.3s ease;

  &:hover {
    color: ${props => (props.isDarkMode ? '#ff6347' : '#2d89ff')};
  }
`;

const Footer = ({ isDarkMode }) => {
  return (
    <FooterWrapper isDarkMode={isDarkMode}>
      <FooterContent>
        <p>&copy; 2026 Les Z'Ineuvitables. Tous droits réservés.</p>
        <SocialMediaWrapper>
        
          <SocialIcon
            href="https://www.instagram.com/leszineuvitables/"
            target="_blank"
            rel="noopener noreferrer"
            aria-label="Instagram"
            isDarkMode={isDarkMode}
          >
            <FaInstagram />
          </SocialIcon>
          <SocialIcon
            href="https://bsky.app/profile/leszineuvitables.bsky.social"
            target="_blank"
            rel="noopener noreferrer"
            aria-label="Bluesky"
            isDarkMode={isDarkMode}
          >
            <FontAwesomeIcon icon={faBluesky} />
          </SocialIcon>
          <SocialIcon
            href="https://linktr.ee/zineuvitables"
            target="_blank"
            rel="noopener noreferrer"
            aria-label="Linktree"
            isDarkMode={isDarkMode}
          >
            <FaLink />
          </SocialIcon>
          <SocialIcon
            href="https://leszineuvitables.blogspot.com/"
            target="_blank"
            rel="noopener noreferrer"
            aria-label="Blogger"
            isDarkMode={isDarkMode}
          >
            <FaBlogger />
          </SocialIcon>
        </SocialMediaWrapper>
        <Credit isDarkMode={isDarkMode}>
          Développé 💻 par{' '}
          <strong>
            <a
              href="https://github.com/Pelle-zebuth"
              target="_blank"
              rel="noreferrer noopener"
              style={{
                textDecoration: 'none',
                color: 'inherit',
                display: 'inline-flex',
                alignItems: 'center',
              }}
            >
              Clemins
              <FaGithub style={{ fontSize: '20px', marginLeft: '8px' }} />
            </a>
            
          </strong>
        </Credit>
                <Credit isDarkMode={isDarkMode}>
          Design du logo et des affiches 🌟 par{' '}
          <strong>
            <a
              href="https://www.behance.net/elisafache1/info"
              target="_blank"
              rel="noreferrer noopener"
              style={{
                textDecoration: 'none',
                color: 'inherit',
                display: 'inline-flex',
                alignItems: 'center',
              }}
            >
              Elisa Fache
              <FaBehance style={{ fontSize: '20px', marginLeft: '8px' }} />
            </a>
            
          </strong>
        </Credit>
        <p>
          <PrivacyPolicyLink href="/privacypolicy" isDarkMode={isDarkMode}>
            Politique de confidentialité
          </PrivacyPolicyLink>
        </p>
           {/* Nouveau bouton gérer les cookies */}
        <p>
          <button
            onClick={() => window.openCookieModal && window.openCookieModal()}
            style={{
              background: 'none',
              border: 'none',
              color: isDarkMode ? '#ddd' : '#555',
              cursor: 'pointer',
              textDecoration: 'underline',
              fontSize: '14px',
              marginTop: '10px',
            }}
          >
            Gérer mes cookies
          </button>
        </p>
      </FooterContent>
    </FooterWrapper>
  );
};

export default Footer;
